/**
 * Shared Utilities - Moon Moon Agency
 * Essential utilities and helpers shared across all modules
 */

/*********************************************************************************************
 * 🌐 GLOBAL SETTINGS
 */
// Development mode detection (self-contained)
window.isDev = ['localhost', '127.0.0.1'].includes(location.hostname)
	|| location.hostname.startsWith('192.168.')
	|| location.hostname.startsWith('10.0.');

// Breakpoints (synced with CSS — desktop-first)
window.WIDE_BREAKPOINT = 1440;
window.MEDIUM_DESKTOP_BREAKPOINT = 1280;
window.SMALL_DESKTOP_BREAKPOINT = 1024;
window.TABLET_BREAKPOINT = 990;
window.MOBILE_BREAKPOINT = 768;

/*********************************************************************************************
 * 🛠️ SHARED UTILITIES
 */
// Simple logging utility
window.log = (level, module, message, data = {}) => {
	if (!window.isDev && level === 'info') return;
	if (typeof console !== 'undefined') {
		const logFn = console[level] || console.log;
		const timestamp = window.getTimestamp?.() || new Date().toLocaleString();
		logFn(`${module} ${message}`, { timestamp, ...data });
	}
};

// Simple event emitter
window.emit = (event, detail = {}, cancelable = false) => {
	// timestamp uniquement en dev (toLocaleString coûteux, ne sert qu'au debug)
	const timestamp = window.isDev ? (window.getTimestamp?.() || '') : null;
	return document.dispatchEvent(new CustomEvent(event, {
		detail: { timestamp, ...detail },
		cancelable,
		bubbles: true
	}));
};

// DOM utilities
window.getElement = (selector) => document.querySelector(selector);
window.getElements = (selector) => document.querySelectorAll(selector);

// Device detection (use these instead of hardcoded breakpoints in modules)
window.isMobile = () => window.innerWidth <= window.MOBILE_BREAKPOINT;
window.isTablet = () => window.innerWidth <= window.TABLET_BREAKPOINT;
window.isSmallDesktop = () => window.innerWidth <= window.SMALL_DESKTOP_BREAKPOINT;
window.isMediumDesktop = () => window.innerWidth <= window.MEDIUM_DESKTOP_BREAKPOINT;
window.isWide = () => window.innerWidth > window.WIDE_BREAKPOINT;
window.isDesktop = () => window.innerWidth > window.TABLET_BREAKPOINT;

// Appareil tactile sans souris (tablette/téléphone). Synchro CSS : même condition
// (hover: none) and (pointer: coarse) pour forcer le menu mobile, indépendamment de la largeur.
window.mmIsTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;
window.debounce = (fn, delay) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn(...args), delay);
	};
};

/*********************************************************************************************
 * 🕐 TIMESTAMP UTILITIES
 */
// French timestamp formatter
window.getTimestamp = () => new Date().toLocaleString('fr-FR', {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit'
});

/*********************************************************************************************
 * 🎯 ACCESSIBILITY - Share URL Select on Click (replace inline onclick)
 */
document.addEventListener('DOMContentLoaded', () => {
	if (window.Splide) {
		window.Splide.defaults.focusableNodes = 'a:not([aria-hidden="true"]), button:not([aria-hidden="true"]), textarea, input, select, iframe';
		if (window.splideStrings) window.Splide.defaults.i18n = window.splideStrings;
	}

	document.querySelectorAll('[data-share-url]').forEach((input) => {
		input.addEventListener('click', () => {
			input.select();
		});
	});
});